import { Router, Switch, Route, Redirect, RouteComponentProps } from "react-router";
import { Suspense, lazy, useEffect } from "react";
import * as React from "react";
import { LandingLayoutWithRouter } from "src/components/template/layouts/LandingLayoutWithRouter";
import Login from "src/pages/auth/Login";
import { Logout } from "src/pages/logout/Logout";
import SecureRoute from "src/pages/PrivateRoute";
import { AuthContext } from "src/components/context/AuthContext";
import Loading from "../components/common/Loading";

export function Institucional(props: RouteComponentProps) {
  const { currentEmail, currentUser, isClient, signOut } = React.useContext(AuthContext);

  useEffect(() => {
    if (currentEmail && currentUser && !isClient()) {
      signOut();
    }
  }, [currentUser]);

  const About = lazy(() => import("./about/About"));
  const NotFound = lazy(() => import("./erros/NotFound"));
  const Precatorios = lazy(() => import("./meus-precatorios"));
  const Documentos = lazy(() => import("./documentos"));
  const Antecipar = lazy(() => import("./meus-precatorios/antecipar"));
  const Consult = lazy(() => import("./consult/ConsultPage"));
  const Migalhas = lazy(() => import("src/pages/consult/migalhas/MigalhasConsult"));
  const PasswordRecover = lazy(() => import("./password-recover/PasswordRecover"));
  const ServiceTerms = lazy(() => import("./terms/ServiceTerms"));
  const PrivacyPolicy = lazy(() => import("./terms/PrivacyPolicy"));

  const UseTerm = lazy(() => import("./meus-precatorios/antecipar/termos-condicos-gerais"));
  const TermoCondicoesGerais = lazy(() => import("./meus-precatorios/antecipar/termos-condicos-gerais/TermoCondicoesGerais"));
  const BankInfo = lazy(() => import("./meus-precatorios/antecipar/dados-bancarios"));
  const ContractInfo = lazy(() => import("./meus-precatorios/antecipar/dados-pessoais"));
  const DocumentsUpload = lazy(() => import("./meus-precatorios/antecipar/upload-documento"));
  const DocumentsValidation = lazy(() => import("./meus-precatorios/antecipar/aprovacao-documento"));
  const UserDataAnalysis = lazy(() => import("./meus-precatorios/antecipar/analise-dados"));
  const DocumentsAnalysis = lazy(() => import("./meus-precatorios/antecipar/validando-documentacao"));
  const PaymentConfirmation = lazy(() => import("./meus-precatorios/antecipar/pagamento-efetuado"));
  const TradeRejected = lazy(() => import("./meus-precatorios/antecipar/rejeitado"));

  return (
    <Router history={props.history}>
      <LandingLayoutWithRouter>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route path="/meus-precatorios/termos-e-condicoes-gerais" component={TermoCondicoesGerais} />

            <Route exact={true} path="/" render={() => (currentEmail && currentUser && isClient() ? <Redirect to="/meus-precatorios/resumo" /> : <Login />)} />
            <Route path="/sobre" component={router => <About {...router} />} />
            <Route
              path="/consulta/migalhas/:data"
              render={(router: any) => (currentEmail && currentUser && isClient() ? <Redirect to="/meus-precatorios" /> : <Migalhas {...router} />)}
            />
            <Route
              path="/consulta/migalhas"
              render={(router: any) => (currentEmail && currentUser && isClient() ? <Redirect to="/meus-precatorios" /> : <Migalhas {...router} />)}
            />
            <Route
              path="/consulta/:data"
              render={(router: any) => (currentEmail && currentUser && isClient() ? <Redirect to="/meus-precatorios/resumo" /> : <Consult {...router} />)}
            />
            <Route path="/consulta" render={(router: any) => (currentEmail && currentUser && isClient() ? <Redirect to="/meus-precatorios/resumo" /> : <Consult {...router} />)} />
            <Route path="/logout" render={(router: any) => <Logout {...router} />} />
            <Route path="/recuperar-senha" render={() => (currentEmail && currentUser && isClient() ? <Redirect to="/meus-precatorios/resumo" /> : <PasswordRecover />)} />
            <Route path="/termos-de-uso" component={ServiceTerms} />
            <Route path="/politicas-de-privacidade" component={PrivacyPolicy} />

            {/* Fluxo Antecipar Trade */}
            <SecureRoute path="/meus-precatorios/termos-e-condicoes-gerais" component={router => <TermoCondicoesGerais {...router} />} />
            <SecureRoute path="/meus-precatorios/resumo" component={router => <Precatorios {...router} />} />
            {/* <SecureRoute path="/meus-precatorios/resumo" component={router => <ResumoBlackFriday {...router} />} /> */}
            <SecureRoute path="/meus-precatorios/:id/antecipar" component={router => <Antecipar {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/aceite-termo-e-condicoes" component={router => <UseTerm {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/dados-pessoais" component={router => <ContractInfo {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/dados-bancarios" component={router => <BankInfo {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/upload-documento" component={router => <DocumentsUpload {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/aprovacao-documento" component={router => <DocumentsValidation {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/analise-dados" component={router => <UserDataAnalysis {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/validando-documentacao" component={router => <DocumentsAnalysis {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/completar-precatorio" component={router => <Documentos {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/pagamento-efetuado" component={router => <PaymentConfirmation {...router} />} />
            <SecureRoute path="/meus-precatorios/:id/rejeitado" component={router => <TradeRejected {...router} />} />
            <Route component={router => <NotFound {...router} />} />
          </Switch>
        </Suspense>
      </LandingLayoutWithRouter>
    </Router>
  );
}



// WEBPACK FOOTER //
// ./src/pages/index.tsx